<app-dialog class="user-delegate-dialog" [loading]="isLoading">
  <ng-container dialog-title> Vertretereinstellungen </ng-container>

  <ng-container dialog-content>
    <span class="sub-text bolder">Delegieren an </span><span class="separator">|</span> <span class="sub-text">Wählen Sie eine Vertretung aus</span>
    <mat-form-field class="width-full" floatLabel="never">
      <input matInput type="text" [formControl]="newKamControl" placeholder="E-Mail Adresse eingeben" [matAutocomplete]="autoKam" />
      <mat-autocomplete autoActiveFirstOption #autoKam="matAutocomplete" [displayWith]="displayKam">
        <mat-option *ngFor="let kam of filteredKams | async" [value]="kam">
          <div class="kam-name" (click)="select(kam)">{{ kam.displayName }}</div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>
  <ng-container dialog-actions align="center">
    <button class="btn btn-outline-primary" (click)="cancel()">Abbrechen</button>
    <button class="btn btn-outline-primary" (click)="confirm()" [disabled]="!!!selectedKam">Delegieren</button>
  </ng-container>
</app-dialog>
